import React, { useRef, useState } from "react";
import { RCCCheckBox, RCCIcon, RCCVerticalTimeline, RCCVerticalTimelineElement } from "react-common-components";
import formatDate from "src/utils/formatDate";
import Title from "../Title";
import ITimelineVertical, { ITimelineDTO } from "./interface";
import StyledP from "./styles";

const TimelineVertical: React.FC<ITimelineVertical> = ({
	data,
	nameOfCheckbox,
	nameOfObject,
	nameOfID,
	nameOfValue,
	register,
	onCallbackSelectCheckbox,
	submitPreviouslyCheckedValues = false,
	restrictSequentialCheckin = true,
	disabled
}) => {
	const divRef = useRef<HTMLDivElement>(null);
	const [state, setState] = useState<ITimelineDTO[]>(data);
	const [lastIndexChecked, setLastIndexChecked] = useState(data.map((dt) => dt.checked).lastIndexOf(true));
	const onChangeCapture = (e: React.ChangeEvent<HTMLInputElement>, index: number) => { 
		if(e.target.checked)
			setLastIndexChecked(index);
		else
			setLastIndexChecked(index - 1);
		
		setState((prevState) => {
			const changePrevState = prevState;
			changePrevState[index].internalChecked = e.target.checked;
			changePrevState[index].checked = e.target.checked;
			return changePrevState;
		});
	}; 
	const onClickIcon = (notExecute: boolean, onClickNameOfCheckbox: string) => {
		if(notExecute)
			return;
		const checkbox = divRef.current?.querySelectorAll(`input[name="${onClickNameOfCheckbox}"]`)[0] as HTMLInputElement;
		if(checkbox)
		    checkbox.click();
	};
	return <div ref={divRef}><RCCVerticalTimeline>
		{state && state.length > 0 && state.map((dt, index) => (
			<RCCVerticalTimelineElement
				key={dt.id}
				className={`vertical-timeline-element--work ${restrictSequentialCheckin && (dt.checked || lastIndexChecked + 1 < index) ? "disabled" : ""}`}
				date={dt.date ? formatDate(dt.date) : undefined}
				iconStyle={{ background: "var(--input-background-color)" }}
				icon={dt.checked || dt.internalChecked ? <RCCIcon name="check" color="var(--default-color-font)"/> : undefined}
				iconOnClick={() => onClickIcon(restrictSequentialCheckin ? lastIndexChecked !== index && lastIndexChecked + 1 !== index : false, `${nameOfObject}[${index}].${nameOfCheckbox}`)}
			>
				{submitPreviouslyCheckedValues ? (
					<>
						<input 
							name={`${nameOfObject}[${index}].${nameOfID}`} 
							type="text"
							value={dt.id}
							{...register(`${nameOfObject}[${index}].${nameOfID}`)} 
							style={{ display: "none" }} 
							readOnly
						/>
						<RCCCheckBox 
							name={`${nameOfObject}[${index}].${nameOfCheckbox}`}
							defaultChecked={dt.checked}
							disabled={disabled || restrictSequentialCheckin ? dt.checked ||  lastIndexChecked + 1 < index : false}
							register={register}
							onChangeCapture={onCallbackSelectCheckbox ? (e: React.ChangeEvent<HTMLInputElement>) => { onChangeCapture(e, index); onCallbackSelectCheckbox(dt, e.target.checked); }: (e: React.ChangeEvent<HTMLInputElement>) => onChangeCapture(e, index)}
							styleInline={{
								checkbox: "position: absolute; right: 4px; top: 0; display: none;"
							}}
						/>
						{nameOfValue && (
							<input 
								name={`${nameOfObject}[${index}].${nameOfValue}`} 
								type="number"
								value={dt.value || 0}
								{...register(`${nameOfObject}[${index}].${nameOfValue}`)} 
								style={{ display: "none" }} 
								readOnly
							/>
						)}
					</>
				) : (
					<>
						{!dt.checked && (
							<>
								<input 
									name={`${nameOfObject}[${index}].${nameOfID}`} 
									type="text"
									value={dt.id}
									{...register(`${nameOfObject}[${index}].${nameOfID}`)} 
									style={{ display: "none" }} 
									readOnly
								/>
								<RCCCheckBox 
									name={`${nameOfObject}[${index}].${nameOfCheckbox}`}
									defaultChecked={dt.checked}
									disabled={disabled || restrictSequentialCheckin ? dt.checked || lastIndexChecked + 1 < index : false}
									register={register}
									onChangeCapture={onCallbackSelectCheckbox ? (e: React.ChangeEvent<HTMLInputElement>) => { onChangeCapture(e, index); onCallbackSelectCheckbox(dt, e.target.checked); }: (e: React.ChangeEvent<HTMLInputElement>) => onChangeCapture(e, index)}
									styleInline={{
										checkbox: "position: absolute; right: 4px; top: 0; display: none;"
									}}
								/>
								{nameOfValue && (
									<input 
										name={`${nameOfObject}[${index}].${nameOfValue}`} 
										type="number"
										value={dt.value || 0}
										{...register(`${nameOfObject}[${index}].${nameOfValue}`)} 
										style={{ display: "none" }} 
										readOnly
									/>
								)}
							</>
						)}
					</>
				)}
				<Title color="purple" size="md">{dt.title}</Title>
				<StyledP>{dt.text}</StyledP>
			</RCCVerticalTimelineElement>
		))}
	</RCCVerticalTimeline></div>;};

export default TimelineVertical;
